import {InventoryQualityTableColumns} from '../components/my-brand-screen/types';
import {SortFieldType} from '../components/my-campaigns-screen/types';

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
  default = 'default',
}

export interface SortClickEvent {
  field: InventoryQualityTableColumns;
  direction: SortDirection;
}

export interface SortOptions {
  sortField?: SortFieldType;
  isAsc?: boolean;
}

export const defaultSortOptions: SortOptions = {}
const directions = [
  SortDirection.default,
  SortDirection.desc,
  SortDirection.asc,
]

export class SortState {
  private sortDirections: SortDirection[] = directions;
  private sortIndex: number = 0;

  public direction = this.sortDirections[this.sortIndex];

  constructor(initialDirection?: SortDirection) {
    if (initialDirection) {
      this.sortIndex = this.sortDirections.findIndex((dir)=> dir === initialDirection);
      this.updateCurrentSortDirection();
    }
  }

  private incSortIndex(): void {
    this.sortIndex = (this.sortIndex + 1) % this.sortDirections.length;
  }

  private updateCurrentSortDirection(): void {
    this.direction = this.sortDirections[this.sortIndex];
  }

  public change(toDefault: boolean = false): void {
    toDefault ? this.sortIndex = 0 :  this.incSortIndex()
    this.updateCurrentSortDirection();
  }

  public seSortDirection(direction: SortDirection): void {
    this.sortIndex = this.sortDirections.indexOf(direction);
    this.updateCurrentSortDirection();
  }

}
